// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Answer_wrapper__om2VX","active":"Answer_active__3OCLm"};